import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

export default function Lightbox({ photos, index, onClose, onNav }) {
  useEffect(() => {
    const h = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNav(1);
      if (e.key === 'ArrowLeft') onNav(-1);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose, onNav]);

  const photo = photos[index];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-[70] flex flex-col bg-ink/95"
      onClick={onClose}
      data-testid="lightbox"
    >
      <div className="flex items-center justify-between px-6 py-5 md:px-10">
        <span className="text-[10px] uppercase tracking-[0.3em] text-paper/60">
          {String(index + 1).padStart(2, '0')} / {String(photos.length).padStart(2, '0')}
        </span>
        <button
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          data-testid="lightbox-close"
          aria-label="Close"
          className="text-paper/70 transition-colors hover:text-paper"
        >
          <X size={26} strokeWidth={1.25} />
        </button>
      </div>
      <div className="relative flex min-h-0 flex-1 items-center justify-center px-4 pb-8 md:px-24">
        <motion.img
          key={photo.s}
          src={`/work/${photo.s}.jpg`}
          alt=""
          data-testid="lightbox-image"
          onClick={(e) => e.stopPropagation()}
          initial={{ opacity: 0, scale: 0.985 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="max-h-full max-w-full object-contain"
        />
        <button
          onClick={(e) => { e.stopPropagation(); onNav(-1); }}
          data-testid="lightbox-prev"
          aria-label="Previous photo"
          className="absolute left-4 top-1/2 -translate-y-1/2 text-paper/60 transition-colors hover:text-paper md:left-8"
        >
          <ChevronLeft size={34} strokeWidth={1.25} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onNav(1); }}
          data-testid="lightbox-next"
          aria-label="Next photo"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-paper/60 transition-colors hover:text-paper md:right-8"
        >
          <ChevronRight size={34} strokeWidth={1.25} />
        </button>
      </div>
    </motion.div>
  );
}
